
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsDiscCouponTypeSerialDialog extends Serenity.EntityDialog<PsDiscCouponTypeSerialRow, any> {
        protected getFormKey() { return PsDiscCouponTypeSerialForm.formKey; }
        protected getIdProperty() { return PsDiscCouponTypeSerialRow.idProperty; }
        protected getLocalTextPrefix() { return PsDiscCouponTypeSerialRow.localTextPrefix; }
        protected getNameProperty() { return PsDiscCouponTypeSerialRow.nameProperty; }
        protected getService() { return PsDiscCouponTypeSerialService.baseUrl; }
        protected getDeletePermission() { return PsDiscCouponTypeSerialRow.deletePermission; }
        protected getInsertPermission() { return PsDiscCouponTypeSerialRow.insertPermission; }
        protected getUpdatePermission() { return PsDiscCouponTypeSerialRow.updatePermission; }

        protected form = new PsDiscCouponTypeSerialForm(this.idPrefix);

    }
}